module.exports = __webpack_public_path__ + "img/LS-M-13.87aa5a29.svg";